export interface TopLevelModule {
  slug: string;
  title: string;
  summary: string;
}

export const topLevelModules: readonly TopLevelModule[] = [
  {
    slug: 'naturalization-status',
    title: 'Naturalization & Status',
    summary: 'Protect the highest-priority critical path.',
  },
  {
    slug: 'marriage-routes',
    title: 'Marriage & Relationship',
    summary: 'Compare routes, paperwork and professional gates.',
  },
  {
    slug: 'family-procedure-property',
    title: 'Family Procedure & Property',
    summary: 'Keep facts, controls and jurisdiction separate.',
  },
  {
    slug: 'child-custody-relocation',
    title: 'Children & Parenting',
    summary: 'Plan citizenship, travel consent and care evidence.',
  },
  {
    slug: 'career-markets',
    title: 'Career',
    summary: 'Build evidence and reversible market experiments.',
  },
  {
    slug: 'startup-business',
    title: 'Startup & Business',
    summary: 'Order work authorization, substance and compliance gates.',
  },
  {
    slug: 'tax-wealth-property',
    title: 'Tax, Wealth & Property',
    summary: 'Track residence, reporting and lawful planning.',
  },
  {
    slug: 'insurance-estate',
    title: 'Insurance & Estate',
    summary: 'Review liquidity, protection and incapacity foundations.',
  },
  {
    slug: 'health-wellbeing',
    title: 'Health & Wellbeing',
    summary: 'Maintain clinician-led preventive-care status.',
  },
  {
    slug: 'parents-family-support',
    title: 'Parents & Family Support',
    summary: 'Assign support and emergency ownership.',
  },
  {
    slug: 'language-community',
    title: 'Language & Community',
    summary: 'Build measured language and community habits.',
  },
  {
    slug: 'wealth-retirement',
    title: 'Retirement',
    summary: 'Reconcile pension records and assumptions.',
  },
  {
    slug: 'global-mobility-tax-startup',
    title: 'Global Mobility',
    summary: 'Compare genuine migration routes and blockers.',
  },
  {
    slug: 'digital-security',
    title: 'Digital Security',
    summary: 'Protect credentials, recovery and backups.',
  },
];
